import {OrbitComponent} from "../../components/base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {CyCssClass} from "../../../common/cy-classes";
import React from "react";

interface IntersectionSpyComponentProps {
    onIntersect: () => void;
    onFailedToCreateIntersectionSpy?: () => void;
    onCaptureIntersectionSpyRef?: (element: HTMLElement) => void;
    cyClass?: CyCssClass;
}

@observer
export class IntersectionSpyComponent extends OrbitComponent<IntersectionSpyComponentProps> {
    private _intersectionObserver: IntersectionObserver = null;


    componentWillUnmount() {
        super.componentWillUnmount();
        this._destroyIntersectionObserver();
    }

    private _captureIntersectionSpy = (element: HTMLElement) => {
        this._createIntersectionObserver(element);
        if(this.props.onCaptureIntersectionSpyRef) {
            this.props.onCaptureIntersectionSpyRef(element);
        }
    }

    private _createIntersectionObserver(element: HTMLElement) {
        this._destroyIntersectionObserver();

        if(!element) {
            return;
        }

        try {
            this._intersectionObserver = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    this.props.onIntersect();
                }
            });

            this._intersectionObserver.observe(element);
        } catch (err) {
            this.services.logger.error('Failed to create intersection spy', err);
            if(this.props.onFailedToCreateIntersectionSpy) {
                this.props.onFailedToCreateIntersectionSpy();
            }
        }

    }

    private _destroyIntersectionObserver() {
        if(this._intersectionObserver) {
            this._intersectionObserver.disconnect();
            this._intersectionObserver = null;
        }
    }

    render() {
        return (
            <div className={this.props.cyClass}
                 style={{ width: "100%", height: "1px" }}
                 ref={this._captureIntersectionSpy}/>
        );
    }
}